import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { ForbiddenError } from 'src/app/service/error.service';
import { environment } from 'src/environments/environment';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  __: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean> => {
  const { authenticated, grantedRoles } = authData;
  const requiredRoles = route.data['role'];
  const requiredEnv = route.data['env'];

  if (!requiredRoles) {
    return false;
  }

  const hasRequiredRole = (roles: string | string[]): boolean => {
    if (Array.isArray(roles)) {
      return roles.some(role =>
        Object.values(grantedRoles.realmRoles).some(r => r.includes(role))
      );
    }
    return Object.values(grantedRoles.realmRoles).some(r => r.includes(roles));
  };

  const hasRequiredEnv = !requiredEnv || environment.env.includes(requiredEnv);

  if (authenticated && hasRequiredRole(requiredRoles) && hasRequiredEnv) {
    return true;
  }

  throw new ForbiddenError();
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);